import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import InventoryPage, { DispatchProps, OwnProps, StateProps } from 'components/pages/inventory/InventoryPage';

import { getYearCategoryFilters, InventoryFilterDataAction } from 'redux/modules/inventory_filter_data';

const mapStateToProps = (state: IRootState): StateProps => {
    const { inventory_filter_data } = state;
    return { inventory_filter_data };
};

const mapDispatchToProps = (dispatch: Dispatch<InventoryFilterDataAction>): DispatchProps => {
    return { load_filter_data: () => dispatch<any>(getYearCategoryFilters()) };
};

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(InventoryPage);



// WEBPACK FOOTER //
// ./src/containers/pages/inventory/InventoryPage.tsx